import { Component, Host, Prop, h } from '@stencil/core';
import { Article } from '../../types';

declare global {
  interface Window {
    getTranslation: any;
  }
}

@Component({
  tag: 'kwo-article-card',
})
export class KwoArticleCard {
  @Prop() article: Article;

  componentDidLoad() {}

  render() {
    return (
      <Host>
        <a class="Teaser__link h-100" href={this.article.url}>
          <div class="Teaser d-flex flex-column justify-content-between h-100">
            <div class="position-relative">
              <div class="TeaserCard__image position-relative mb-md">
                <picture>
                  <img src={this.article.image.url} alt={this.article.image.alt} class="img-fluid" />
                </picture>
              </div>

              { this.article.category.title && (
                <div class="position-absolute top-0 p-md z-1">
                  <span class={`Badge Badge--${this.article.category.color}`}>{this.article.category.title}</span>
                </div>
              )}

              <div class="px-lg-md">
                <h3 class="TeaserCard__title h4 mb-sm" innerHTML={this.article.title}></h3>

                { this.article.text && (
                  <div class="TeaserCard__text d-none d-lg-block" innerHTML={this.article.text}></div>
                )}

              </div>
            </div>

            <div class="col-12">
                <div class="px-lg-md mt-md">
                  <span class="btn btn-tertiary small">
                    {window.getTranslation('read-more')}<lg-icon name="arrow-up-right-thin" class="ms-sm"></lg-icon>
                  </span>
                </div>
                <div class="mt-md"><hr class="m-0" /></div>
            </div>
          </div>
        </a>
      </Host>
    );
  }
}
